import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { Organization } from '../data/organization';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.css']
})
export class OrganizationsComponent extends BaseComponent implements OnInit {

  @Input() searchValue: string = "";
  orgs: Organization[];
  typeFilter: string;

  ngOnInit() {
    if (this.organizationService.hasRootAdminOrg()) {
      this.router.navigateByUrl(this.redirectService.getRedirectUrl());
    }
    this.getOrganizations();
  }

  onInput(val: string) {
    this.searchValue = val;
  }


  getOrganizations(term?: string): void {
    this.dataService.getOrganizations(term)
      .subscribe(organizations => {
        if (organizations) {
          this.organizationService.setOrgs(organizations);
          this.handleOrganizations(this.organizationService.getRootOrgs());
        }
      });
  }

  handleOrganizations(organizations: Organization[]): void {
    this.allListItems = organizations;
    this.orgs = organizations;
  }

  performSearch(term: string): Observable<any> {
    return this.dataService.getOrganizations(term);
  }

  // filterOnType(typeFilter: string) {
  //   this.typeFilter = typeFilter;
  //   if (typeFilter) {
  //     this.listItems$ = of(this.cacheService.organizations.filter(org => org.TypeCode === typeFilter));
  //   }
  //   else {
  //     this.listItems$ = of(this.cacheService.organizations);
  //   }
  // }
}
